import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  card: {
    backgroundColor: "white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: 10,
    width: 350,
    gap: 15,
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    "& h2": {
      margin: 0,
      fontWeight: 500,
      fontSize: "24px"
    },
    "& span": {
      color: "#667185",
      fontSize: "14px"
    }
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    border: "none",
    borderRadius: 40,
    padding: theme.spacing(2, 3),
    cursor: "pointer",
    width: "fitContent"
  },
  modalFooterBtn: {
    display: "flex",
    width: "100%",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 500px)": {
      flexWrap: "wrap"
    }
  },
  mail: {
    cursor: "pointer",
    gap: "2px",
    color: "#0065FF",
    fontWeight: "500",
    lineHeight: "17.4px"
  }
}));
